import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'anschlusspilot_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Slight delay so it doesn't pop up immediately on load
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      choice,
      timestamp: new Date().toISOString(),
    }));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 200, damping: 25 }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[60]"
          data-testid="cookie-consent-banner"
        >
          <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
            <div className="p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-500 flex items-center justify-center flex-shrink-0">
                    <Cookie className="h-5 w-5 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">Cookies & Datenschutz</h3>
                </div>
                <button
                  onClick={() => handleChoice('declined')}
                  className="text-gray-400 hover:text-gray-600 transition-colors -mt-1 -mr-1 p-1"
                  aria-label="Schließen"
                  data-testid="cookie-close-btn"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              <p className="text-sm text-gray-600 leading-relaxed mb-5">
                Wir verwenden ausschließlich technisch notwendige Cookies, um Ihnen die Funktionen unserer Website zu ermöglichen. Es findet kein Tracking durch Drittanbieter statt. Mehr in unserer{' '}
                <Link to="/datenschutz" className="text-cyan-600 hover:underline font-medium">
                  Datenschutzerklärung
                </Link>.
              </p>

              <div className="flex flex-col sm:flex-row gap-2">
                <button
                  onClick={() => handleChoice('accepted')}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-white text-sm font-semibold rounded-xl shadow-md shadow-cyan-500/20 transition-all hover:scale-[1.02]"
                  data-testid="cookie-accept-btn"
                >
                  Verstanden
                </button>
                <button
                  onClick={() => handleChoice('declined')}
                  className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-semibold rounded-xl transition-colors"
                  data-testid="cookie-decline-btn"
                >
                  Ablehnen
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
